<template>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';

export default {
  name: 'Auth',
  data () {
    return {
      app_id: '',
      username: '',
      password: '',
      loginUrl: ''
    }
  },
  created () {
    var client_id = this.$route.query.app_id
    var loginUrl = process.env.SERVICES[client_id]
    if (loginUrl) {
      this.app_id = client_id
      this.loginUrl = loginUrl
    }
    this.$cognito.isAuthenticated().then(session => {
      if (this.loginUrl) {
        var config = {
          headers: { 
            'id-token': session.idToken.jwtToken,
            'access-token': session.accessToken.jwtToken,
            'refresh-token': session.refreshToken.token
          }
        }
        if (this.app_id == 'camp') {
          window.location.href = this.loginUrl
            + '?uid=' +  this.username
            + '&idToken=' + result.idToken.jwtToken
            + '&accessToken=' + result.accessToken.jwtToken
            + '&refreshToken=' + result.refreshToken.token
        } else {
          if (this.app_id == 'ec') config['withCredentials'] = true 
          axios.get(this.loginUrl, config)
            .then((res) => {
              if (res.status == 200) {
                window.location.href = res.data.url
              } else {
                this.$router.replace('/home')
              }
            })
        }
       } else {
         this.$router.replace('/home')
       }
    }).catch(session => {
      this.$router.replace('/login?app_id=' + this.app_id)
    })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Auth.vue